import { STUDIO_SESSION_DETAIL } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import StudioSessionPage from "./container/StudioSessionPage";

export default function getSettingsRoute(userAuth) {
  const { account, rhapsody } = serviceRoles;
  const requireAuth = {
    [rhapsody.name]: [account.roles.user],
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: STUDIO_SESSION_DETAIL,
    withSidebar: true,
    withAppBar: true,
    component: StudioSessionPage,
  };
}
